import { SetStateAction } from 'react';

/**
 * Get value from state action execution
 *
 * @param stateAction
 * @param currentValue
 * @returns
 */
export function getValueFromStateAction<StateType>(
  stateAction: SetStateAction<StateType>,
  currentValue: StateType,
): StateType {
  return typeof stateAction === 'function'
    ? (stateAction as (prevState: StateType) => StateType)(currentValue)
    : stateAction;
}

export default {};
